import React, { Suspense, lazy } from "react";
import Sidebar from "./Sidebar";
import Box from "@mui/material/Box";
import { Navigate, Route, Routes } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import {
  DASHBOARD_ROUTE,
  INVOICEPREVIEW_ROUTE,
  INVOICE_PREVIEW_ROUTE,
  INVOICE_ROUTE,
  METRICSINVOICE_ROUTE,
  MYTEAM_ROUTE,
  SUPPLIER_SITE_ROUTE,
  SETTINGS_ROUTE,
  SUPPLIERMANAGEMENT_ROUTE,
  PROFILE_ROUTE,
  MYCLIENTS_ROUTE,
  ADD_SUPPLIER,
  NOTIFICATION_ROUTE,
  APPROVAL_QUEUES_ROUTE,
  INBOX_ROUTE,
  BUDGET_CODE_MAPPING_ROUTE,
} from "../constants/RoutePaths";

// Lazy load all page components for code splitting
const Dashboard = lazy(() => import("./Dashboard"));
const Invoice = lazy(() => import("./Invoice"));
const BudgetCodeMapping = lazy(() => import("./BudgetCodeMapping"));
const InvoicePreview = lazy(() => import("./InvoicePreview"));
const InvoiceSinglePreview = lazy(() => import("./InvoiceSinglePreview"));
const MyTeam = lazy(() => import("./MyTeam"));
const SupplierManagement = lazy(() => import("./SupplierManagement"));
const Settings = lazy(() => import("./Settings"));
const MetricsInvoice = lazy(() => import("./MetricsInvoice"));
const Profile = lazy(() => import("./Profile"));
const MyClients = lazy(() => import("./MyClients"));
const AddSupplier = lazy(() => import("./AddSupplier"));
const NotificationList = lazy(() => import("./Notification/NotificationList"));
const SupplierDetais = lazy(() => import("./SupplierDetails"));
const QueueDashboard = lazy(() => import("./QueueDashboard"));

// Inbox components
const Inbox = lazy(() => import("./Inbox/Inbox"));
const MyApprovals = lazy(() => import("./Inbox/MyApprovals"));
const InvoicesAll = lazy(() => import("./Inbox/InvoicesAll"));
const CentralReceiving = lazy(() => import("./Inbox/CentralReceiving"));
const DirectPay = lazy(() => import("./Inbox/DirectPay"));
const Facilities = lazy(() => import("./Inbox/Facilities"));

// Loading fallback component
const PageLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    }}
  >
    <CircularProgress sx={{ color: "#FC6634" }} />
  </Box>
);

const Layouts = () => {
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3, pt: 2, minWidth: 0, overflow: "clip" }}>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path={DASHBOARD_ROUTE} element={<Dashboard />}></Route>
              <Route path={NOTIFICATION_ROUTE} element={<NotificationList />}></Route>
              <Route path={APPROVAL_QUEUES_ROUTE} element={<QueueDashboard />}></Route>
              {/* Inbox Routes - Nested under Inbox wrapper */}
              <Route path={INBOX_ROUTE} element={<Inbox />}>
                <Route index element={<Navigate to="my-approvals" replace />} />
                <Route path="my-approvals" element={<MyApprovals />} />
                <Route path="invoices-all" element={<InvoicesAll />} />
                <Route path="central-receiving" element={<CentralReceiving />} />
                <Route path="direct-pay" element={<DirectPay />} />
                <Route path="facilities" element={<Facilities />} />
              </Route>
              <Route path={INVOICE_ROUTE} element={<Invoice />}></Route>
              <Route path={SUPPLIERMANAGEMENT_ROUTE} element={<SupplierManagement />}></Route>
              <Route path={MYCLIENTS_ROUTE} element={<MyClients />}></Route>
              <Route path={ADD_SUPPLIER} element={<AddSupplier />}></Route>
              <Route path={SETTINGS_ROUTE} element={<Settings />}></Route>
              <Route path={METRICSINVOICE_ROUTE} element={<MetricsInvoice />}></Route>
              <Route
                path={`${INVOICEPREVIEW_ROUTE}/:${"invoiceID"}`}
                element={<InvoicePreview />}
              ></Route>
              <Route
                path={`${INVOICE_PREVIEW_ROUTE}/:${"invoiceID"}`}
                element={<InvoiceSinglePreview />}
              ></Route>
              <Route
                path={"" + INVOICEPREVIEW_ROUTE + "/:invoiceID"}
                element={<InvoicePreview />}
              ></Route>
              <Route
                path={"" + SUPPLIER_SITE_ROUTE + "/:supplierID"}
                element={<SupplierDetais />}
              ></Route>
              <Route path={PROFILE_ROUTE} element={<Profile />}></Route>
              <Route path={MYTEAM_ROUTE} element={<MyTeam />}></Route>
              <Route path={BUDGET_CODE_MAPPING_ROUTE} element={<BudgetCodeMapping />}></Route>
              {/* <Route path={AUTHENTIFICATION_ROUTE} element={<Authentification />}></Route> */}
              <Route path={"*"} element={<Navigate to={"pagenotfound"} />}></Route>
            </Routes>
          </Suspense>
        </Box>
      </Box>
    </>
  );
};

export default Layouts;
